import gql from "graphql-tag";

export const DEVICES_QUERY = gql`
  query {
    devices {
      id
    }
  }
`;
